import { DASHBOARD_COUNT } from '../../constants';

const initialState = {
  data: {},
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case DASHBOARD_COUNT.LOAD:
      return {
        ...state,
        loading: true,
      };
    case DASHBOARD_COUNT.SUCCESS:
      return {
        ...state,
        loading: false,
        data: payload,
      };
    case DASHBOARD_COUNT.FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}
